import { PagePopup } from "common/page/model/PageModel";
import { InputMaskOptions } from "components/atoms/input/UIInputMask";
import $ from "jquery";
import { observer } from "mobx-react";
import React from "react";
import StringUtil from "utils/StringUtil";

export interface UIPopupOpenProps {
  value?: string;
  valueChanged?: (data?: any) => any;
  valueSetted?: boolean;
  searchPopup?: (popup: PagePopup) => React.ReactNode;
  searchAction?: (value: string) => void;
  inputMask?: { mask: string; attrs?: InputMaskOptions };
  displayOnly?: boolean;
  btnLabel?: string;
}

export default observer(UIPopupOpen);

function UIPopupOpen(props: UIPopupOpenProps) {
  const [value, setValue] = React.useState<string>(props.value == null ? "" : props.value);
  const [, setValueSetted] = React.useState<boolean>();
  const [searchPopupOpen, setSearchPopupOpen] = React.useState<boolean>(false);

  let $popupWrapper;

  React.useEffect(() => {
    setValue(props.value == null ? "" : props.value);
    setValueSetted(props.valueSetted != null ? props.valueSetted : StringUtil.isNotEmpty(props.value));
  }, [props.value, props.valueSetted]);

  React.useEffect(
    () => {
      $popupWrapper.appendTo(".page_con");
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [$popupWrapper]
  );

  React.useEffect(() => {
    return () => {
      $popupWrapper.remove();
    };
  });

  /*
  const inputTextAttrs: React.InputHTMLAttributes<HTMLInputElement> = {
    type: "text",
    title: valueSetted === true ? value : "검색어를 입력해주세요.",
    className: "form-control form-control-sm",
    disabled: (() => {
      return true;
      // return props.displayOnly != null ? props.displayOnly : false;
    })(),
    onKeyUp: (event) => {
      if (event.key === "Enter") {
        if (typeof props.searchAction === "function") {
          props.searchAction(event.currentTarget.value);
        }
      }
    },
  };
  */

  return (
    <>
      <div ref={(element) => ($popupWrapper = $(element!))}>
        {searchPopupOpen === true &&
          typeof props.searchPopup === "function" &&
          props.searchPopup({
            close: () => setSearchPopupOpen(false),
            result: (data?: any) => {
              let result;

              if (typeof props.valueChanged === "function") {
                result = props.valueChanged(data);
              }

              if (result !== false) {
                if (props.valueSetted == null) {
                  setValueSetted(true);
                }

                setSearchPopupOpen(false);
              } else {
                setValueSetted(false);
              }
            },
          })}
      </div>

      {props.displayOnly !== true && (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => {
            if (typeof props.searchAction === "function") {
              props.searchAction(value);
            } else {
              setSearchPopupOpen(true);
            }
          }}
        >
          <i className="bi bi-save"></i>
          {props.btnLabel || "찾기"}
        </button>
      )}
    </>
  );
}
